module.exports = __webpack_public_path__ + "static/media/recommend.e5ebbfb8.svg";